import React, { lazy } from'react';
import { LoadComponent, type RouteObject  } from'./index';

// Erros e manutenção
export const ErrorPageNotFound = lazy(
  () => import('Pages/System/error/PageNotFound')
);
export const ServerError = lazy(() => import('Pages/System/error/ServerError'));
export const Maintenance = lazy(() => import('Pages/System/Maintenance'));
const Test = lazy(() => import('Pages/System/test'));


const SystemRoutes: RouteObject[]= [
  {
    path:'test',
    element: <LoadComponent component={Test} />,
  },
  {
    path:'error-404',
    element: <LoadComponent component={ErrorPageNotFound} />,
  },
  {
    path:'error-500',
    element: <LoadComponent component={ServerError} />,
  },
  {
    path:'maintenance',
    element: <LoadComponent component={Maintenance} />,
  },
]

export default SystemRoutes;
